import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProtectedRoute from "../Routes/ProtectedRoute"; // ✅ guard
import AdminLayout from "../Layout/Admin_Dashboard";

// Pages
import AdminDashboard from "../pages/Admin/Dashboard";
import Page_Not_Found from "../Components/404_page";
import AdminLogin from "../pages/Admin/Login/login";
import RegisterHotel from "../pages/Admin/Register";
import BuyerLead from "../pages/Admin/Buyer";
import SupplierLead from "../pages/Admin/Supplier";
import Connections from "../pages/Admin/Connection";
import ProdcutList from "../pages/Admin/Supplier/productList";
import Role from "../pages/Admin/Role";
import RolePermission from "../pages/Admin/RolePermission";
import RoleAdd from "../pages/Admin/Role/store";
import RoleShow from "../pages/Admin/Role/show";
import RoleEdit from "../pages/Admin/Role/edit";
import Permission from "../pages/Admin/Permision";
import PermissionAdd from "../pages/Admin/Permision/store";
import PermissionShow from "../pages/Admin/Permision/show";
import PermissionEdit from "../pages/Admin/Permision/edit";
import RolePermissionAdd from "../pages/Admin/RolePermission/store";
import CMS from "../pages/Admin/CMS";
import Contacts from "../pages/Admin/Contacts";
import Consultations from "../pages/Admin/Consultations";
import Product from "../pages/Admin/Product";
import CmsAdd from "../pages/Admin/CMS/store";
import CmsEdit from "../pages/Admin/CMS/edit";
import BuyerShow from "../pages/Admin/Buyer/show";
import CmsShow from "../pages/Admin/CMS/show";
import ProductAdd from "../pages/Admin/Product/store";
import ProductEdit from "../pages/Admin/Product/edit";
import ProductShow from "../pages/Admin/Product/show";
import ConnectionShow from "../pages/Admin/Connection/show";
import Category from "../pages/Admin/Category";
import CategoryAdd from "../pages/Admin/Category/store";
import CategoryEdit from "../pages/Admin/Category/edit";
import CategoryShow from "../pages/Admin/Category/show";
import SubCategory from "../pages/Admin/SubCategory";
import Blog from "../pages/Admin/Blog";
import BlogCategory from "../pages/Admin/BlogCategory";
import BlogCategoryAdd from "../pages/Admin/BlogCategory/store";
import BlogCategoryShow from "../pages/Admin/BlogCategory/show";
import BlogCategoryEdit from "../pages/Admin/BlogCategory/edit";
import BlogAdd from "../pages/Admin/Blog/store";
import BlogEdit from "../pages/Admin/Blog/edit";
import BlogShow from "../pages/Admin/Blog/show";
import Solution from "../pages/Admin/Solution";
import SolutionAdd from "../pages/Admin/Solution/store";
import SolutionEdit from "../pages/Admin/Solution/edit";
import SolutionShow from "../pages/Admin/Solution/show";
import NewsLetters from "../pages/Admin/NewsLetters";
import ProductListBuyer from "../pages/Admin/Buyer/productBuyerList";
import AssignCode from "../pages/Admin/AssignCode";
import AssignCodeAdd from "../pages/Admin/AssignCode/store";
import AssignCodeEdit from "../pages/Admin/AssignCode/edit";
import AssignCodeShow from "../pages/Admin/AssignCode/show";
import AssignOrder from "../pages/Admin/Buyer/AssignOrder";
import SubCategoryEdit from "../pages/Admin/SubCategory/edit";
import SubCategoryShow from "../pages/Admin/SubCategory/show";
import SubCategoryAdd from "../pages/Admin/SubCategory/store";
import DesignStudio from "../pages/Admin/DesignStudio";
import DesignStudioAdd from "../pages/Admin/DesignStudio/store";
import DesignStudioEdit from "../pages/Admin/DesignStudio/edit";
import DesignStudioShow from "../pages/Admin/DesignStudio/show";
import Inbound from "../pages/Admin/Supplier/inbound";
import Outbound from "../pages/Admin/Supplier/outbound";
import RevertBackShow from "../pages/Admin/Buyer/revertback";
import RequestForQuotation from "../pages/Admin/RequestForQuotation";
import SupplierAdd from "../pages/Admin/Supplier/store";
import SupplierBuyLead from "../pages/Admin/Buyer/supplierBuyLead";
import BuyerLeadAdd from "../pages/Admin/Buyer/buyerLeadAddForm";
import UserManagement from "../pages/Admin/UserManagement";
import UserManagementAdd from "../pages/Admin/UserManagement/store";
import DesignStudioProduct from "../pages/Admin/Buyer/DesignStudio";
import UserManagementShow from "../pages/Admin/UserManagement/show";
import UserManagementEdit from "../pages/Admin/UserManagement/edit";
import NewRegistration from "../pages/Admin/NewRegistration";
import SupplierShow from "../pages/Admin/Supplier/show";
import ProfileAdd from "../pages/Admin/Profile/store";
import RFQProductShow from "../pages/Admin/RequestForQuotation/show";
import AssignCodeSupplierAdd from "../pages/Admin/Buyer/assignCodeSupplier";
import SupplierProductShow from "../pages/Admin/Supplier/supplierProductShow";
import LeadAdd from "../pages/Admin/Supplier/LeadAddForm";
import ProductOfflineSupplierBuyerList from "../pages/Admin/Buyer/SupplierOfflineBuyerProductList";
import SupplierbyleadOfflineSupplier from "../pages/Admin/Buyer/SupplierByLeadOfflineAssign";
import NewRegistrationShow from "../pages/Admin/NewRegistration/show";
import BuyerProductEdit from "../pages/Admin/Buyer/productEdit";
import GraphicDesignerList from "../pages/Admin/GraphicDesigner";
import GraphicDesignerDesigns from "../pages/Admin/GraphicDesigner/designs";
import GraphicDesignerForm from "../pages/Admin/GraphicDesigner/store";
import GraphicDesignerEditForm from "../pages/Admin/GraphicDesigner/edit";
import GraphicConnections from "../pages/Admin/GraphicDesigner/connection";
import GraphicDesignerShow from "../pages/Admin/GraphicDesigner/show";
import BuyerFakeLeadAdd from "../pages/Admin/Buyer/fakeLeadAddForm";
import SupplierEdit from "../pages/Admin/Supplier/edit";

const Admin_Routes = () => {
  // ✅ token from frontend redirect (optional)
  const url = new URL(window.location.href);
  const token = url.searchParams.get("token");
  const user = url.searchParams.get("user");

  if (token && user) {
    try {
      const userObj = JSON.parse(user);
      localStorage.setItem("user", JSON.stringify(userObj));
      localStorage.setItem("Token", `${token}`);
    } catch {
      localStorage.setItem("user", user);
      localStorage.setItem("Token", `${token}`);
    }
  }

  return (
    <BrowserRouter>
      <Routes>
        {/* 🔓 Public routes */}
        <Route path="/" element={<AdminLogin />} />
        <Route path="/register" element={<RegisterHotel />} />

        {/* 🔒 Protected admin routes */}
        <Route element={<ProtectedRoute />}>
          <Route element={<AdminLayout />} path="/admin/">
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="new-registration" element={<NewRegistration />} />
            <Route path="buyer/list" element={<BuyerLead />} />
            <Route
              path="buyer/product-list/:userId"
              element={<ProductListBuyer />}
            />
            <Route path="buyer/assign-orders" element={<AssignOrder />} />
            <Route path="buyer/show" element={<BuyerShow />} />
            <Route path="supplier-by-lead/list" element={<SupplierBuyLead />} />
            <Route
              path="revert-back/supplier/:productId/:orderId"
              element={<RevertBackShow />}
            />
            <Route path="supplier/product/list" element={<ProdcutList />} />
            <Route path="supplier/list" element={<SupplierLead />} />
            <Route path="supplier/add" element={<SupplierAdd />} />
            <Route path="supplier/show" element={<SupplierShow />} />
            <Route path="connection/list" element={<Connections />} />
            <Route path="connection/show" element={<ConnectionShow />} />
            <Route path="graphic-designer" element={<GraphicDesignerList />} />
            <Route
              path="graphic-designer/designs/:id"
              element={<GraphicDesignerDesigns />}
            />
            <Route
              path="graphic-designer/store"
              element={<GraphicDesignerForm />}
            />
            <Route
              path="graphic-designer/edit/:id"
              element={<GraphicDesignerEditForm />}
            />
            <Route
              path="graphic-designer/connection/list"
              element={<GraphicConnections />}
            />
            <Route
              path="graphic-designer/show/:id"
              element={<GraphicDesignerShow />}
            />
            <Route path="role" element={<Role />} />
            <Route path="role/add" element={<RoleAdd />} />
            <Route path="role/show" element={<RoleShow />} />
            <Route path="role/edit" element={<RoleEdit />} />
            <Route path="permission" element={<Permission />} />
            <Route path="permission/add" element={<PermissionAdd />} />
            <Route path="permission/show" element={<PermissionShow />} />
            <Route path="permission/edit" element={<PermissionEdit />} />
            <Route path="role-permission" element={<RolePermission />} />
            <Route path="role-permission/add" element={<RolePermissionAdd />} />
            <Route path="cms" element={<CMS />} />
            <Route path="cms/add" element={<CmsAdd />} />
            <Route path="cms/edit" element={<CmsEdit />} />
            <Route path="cms/show" element={<CmsShow />} />
            <Route path="contacts" element={<Contacts />} />
            <Route path="consultations" element={<Consultations />} />
            <Route path="product" element={<Product />} />
            <Route path="product/add" element={<ProductAdd />} />
            <Route path="product/edit" element={<ProductEdit />} />
            <Route path="product/show" element={<ProductShow />} />
            <Route path="category" element={<Category />} />
            <Route path="category/add" element={<CategoryAdd />} />
            <Route path="category/edit" element={<CategoryEdit />} />
            <Route path="category/show" element={<CategoryShow />} />
            <Route path="sub-category" element={<SubCategory />} />
            <Route path="sub-category/add" element={<SubCategoryAdd />} />
            <Route path="sub-category/edit" element={<SubCategoryEdit />} />
            <Route path="sub-category/show" element={<SubCategoryShow />} />
            <Route path="blog" element={<Blog />} />
            <Route path="blog/add" element={<BlogAdd />} />
            <Route path="blog/edit" element={<BlogEdit />} />
            <Route path="blog/show" element={<BlogShow />} />
            <Route path="blog-category" element={<BlogCategory />} />
            <Route path="blog-category/add" element={<BlogCategoryAdd />} />
            <Route path="blog-category/edit" element={<BlogCategoryEdit />} />
            <Route path="blog-category/show" element={<BlogCategoryShow />} />
            <Route path="solution" element={<Solution />} />
            <Route path="solution/add" element={<SolutionAdd />} />
            <Route path="solution/edit" element={<SolutionEdit />} />
            <Route path="solution/show" element={<SolutionShow />} />
            <Route path="news-letters" element={<NewsLetters />} />
            <Route path="assign-order" element={<AssignCode />} />
            <Route path="assign-order/add" element={<AssignCodeAdd />} />
            <Route path="assign-order/edit" element={<AssignCodeEdit />} />
            <Route path="assign-order/show" element={<AssignCodeShow />} />
            <Route path="design-studio" element={<DesignStudio />} />
            <Route path="design-studio/add" element={<DesignStudioAdd />} />
            <Route path="design-studio/edit" element={<DesignStudioEdit />} />
            <Route path="design-studio/show" element={<DesignStudioShow />} />
            <Route path="inbound" element={<Inbound />} />
            <Route path="outbound" element={<Outbound />} />
            <Route
              path="request-for-quotation/list"
              element={<RequestForQuotation />}
            />
            <Route path="buyer/add" element={<BuyerLeadAdd />} />
            <Route path="buyer-fake/add" element={<BuyerFakeLeadAdd />} />
            <Route path="supplier-fake/add" element={<BuyerFakeLeadAdd />} />
            <Route path="usermanagement/list" element={<UserManagement />} />
            <Route path="usermanagement/add" element={<UserManagementAdd />} />
            <Route
              path="usermanagement/edit"
              element={<UserManagementEdit />}
            />
            <Route
              path="usermanagement/show"
              element={<UserManagementShow />}
            />
            <Route
              path="design-studio-forward/add"
              element={<DesignStudioProduct />}
            />
            <Route path="profile-update" element={<ProfileAdd />} />
            <Route path="rfq-product-show" element={<RFQProductShow />} />
            <Route path="assign-supplier" element={<AssignCodeSupplierAdd />} />
            <Route
              path="supplier-product-show"
              element={<SupplierProductShow />}
            />
            <Route path="supplier-buy-lead-add" element={<LeadAdd />} />
            <Route
              path="supplier-offline-assign"
              element={<SupplierbyleadOfflineSupplier />}
            />
            <Route
              path="supplier-offline-product-list/:userId"
              element={<ProductOfflineSupplierBuyerList />}
            />
            <Route
              path="new-registration/show"
              element={<NewRegistrationShow />}
            />
            <Route path="buyer-product-edit" element={<BuyerProductEdit />} />
            {/* Generic user editor (any role). `supplier-edit` kept as a
                legacy alias so older links/bookmarks still resolve. */}
            <Route path="edit-user" element={<SupplierEdit />} />
            <Route path="supplier-edit" element={<SupplierEdit />} />
          </Route>
        </Route>

        {/* 404 */}
        <Route path="*" element={<Page_Not_Found />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Admin_Routes;
